import { useEffect, useState } from "react";

import { errorText, wabaApi } from "../lib/wabaApi";

// Login for Business da Meta pra Instagram e Messenger — fusão de
// apps/frontend/src/components/waba/{InstagramSignup,MessengerSignup}.tsx (só o
// config_id e a rota mudam). Mesmo app do EmbeddedSignup; o script fb-jssdk é
// compartilhado. Config própria por canal: a Meta concede tudo ou nada, e loja
// sem Instagram não conseguiria dar as permissões de IG.

const META_APP_ID = "843063592187222";
const CFG = {
  instagram: { id: "2019580048696525", path: "link-instagram", label: "Conectar Instagram", cor: "#C13584" },
  messenger: { id: "923904130787102", path: "link-messenger", label: "Conectar Messenger", cor: "#0084FF" },
};

export function MetaLogin({ connectionId, kind, onSuccess }: { connectionId: string; kind: keyof typeof CFG; onSuccess: () => void }) {
  const cfg = CFG[kind];
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (document.getElementById("fb-jssdk")) return;
    window.fbAsyncInit = () => { window.FB.init({ appId: META_APP_ID, autoLogAppEvents: true, xfbml: true, version: "v25.0" }); };
    const script = document.createElement("script");
    script.id = "fb-jssdk"; script.src = "https://connect.facebook.net/en_US/sdk.js"; script.async = true; script.defer = true;
    document.body.appendChild(script);
  }, []);

  async function doLink(code: string) {
    try {
      await wabaApi.post(`/connections/${connectionId}/${cfg.path}`, { code });
      onSuccess();
    } catch (err: any) {
      setError(errorText(err, `Erro ao conectar o ${kind === "instagram" ? "Instagram" : "Messenger"}.`));
    } finally { setLoading(false); }
  }

  function handle() {
    if (!window.FB) { setError("SDK da Meta ainda não carregou. Aguarde e tente novamente."); return; }
    setError(null); setLoading(true);
    // callback síncrono: o SDK recusa async function
    window.FB.login((response: any) => {
      const code = response?.authResponse?.code;
      if (!code) { setError("Cadastro cancelado ou código não retornado pela Meta."); setLoading(false); return; }
      doLink(code);
    }, { config_id: cfg.id, response_type: "code", override_default_response_type: true });
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <button onClick={handle} disabled={loading}
        style={{ padding: "9px 18px", background: loading ? "var(--surface-input)" : cfg.cor, color: loading ? "var(--ink-muted)" : "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: loading ? "default" : "pointer" }}>
        {loading ? "Conectando..." : cfg.label}
      </button>
      {error && <span role="alert" style={{ fontSize: 12, color: "var(--danger)" }}>{error}</span>}
    </div>
  );
}
